module.exports = __webpack_public_path__ + "img/Girls_In_The_Game_Poster.460dc9e3.jpg";